import React, { useEffect } from 'react';

import { useLoader } from '@context/Utils';
import './index.scss';

export function Loader() {
  // Constants
  const elemArry = ['#tree2_crown', '#ray1', '#ray2', '#ray3', '#ray4', '#ray5'];

  const { loader } = useLoader();

  // Functions
  function restartAnimation(_element) {
    // eslint-disable-next-line prefer-const
    let elem = document.querySelector(_element);
    if (elem) {
      elem.style.animationName = 'none';
    }

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (elem) {
          elem.style.animationName = '';
        }
      }, 0);
    });
  }

  // Hooks
  useEffect(() => {
    if (loader) {
      setInterval(() => {
        elemArry.forEach((element) => restartAnimation(element));
      }, 6000);
    }
  }, [loader]);

  if (!loader) {
    return <></>;
  }

  return (
    <div id="loader" className="d-flex justify-content-center align-items-center">
      <svg
        version="1.1"
        id="Ebene_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 682.7 682.7"
        style={{ enableBackground: 'new 0 0 682.7 682.7' }}
        xmlSpace="preserve"
      >
        {/* eslint-disable-next-line react/no-unknown-property */}
        <g id="base">
          <path
            id="path347_00000098180197781606911040000001280800621127926430_"
            className="st0"
            d="M177.9,534.5h292.3"
          />
        </g>
        <g id="tree1_stem">
          <g>
            <g
              id="g293_00000139982561805558858490000014966573242503764406_"
              transform="translate(133.0643,146.2694)"
            >
              <path
                id="path295_00000078030362306634267930000005455042167769958059_"
                className="st0"
                d="M84.7,302.9l27.6-27.6"
              />
            </g>
            <g
              id="g297_00000085234417344877341810000001793497040215325342_"
              transform="translate(133.0643,189.3972)"
            >
              <path
                id="path299_00000171698708737627535200000014279806148067469952_"
                className="st0"
                d="M84.7,235.2l-20.8-20.8"
              />
            </g>
            <g id="g283_00000083084135473489975800000006186636486586724487_">
              <g
                id="g289_00000183225362808167156990000011933938497888478632_"
                transform="translate(133.0643,244.8352)"
              >
                <path
                  id="path291_00000072269202338637211260000014360838186984639393_"
                  className="st0"
                  d="M84.7,148.3v133.6"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="tree1_crown">
          <path
            id="path367_00000140693327100270581110000000955388998826879914_"
            className="st0"
            d="M147.7,409.2L147.7,409.2"
          />
          <path
            className="st0"
            d="M149.4,387.9c9.3-28.5,36-49.2,67.6-49.4c39.6-0.3,71.9,31.5,72.1,71.1s-31.5,71.9-71.1,72.1
            c-32.1,0.2-59.4-20.7-68.7-49.7"
          />
        </g>
        <g id="tree2">
          <g>
            <g id="g301_00000121241798936532496320000000212360272358780329_">
              <g id="g303_00000168109777830380310190000007328571786906674597_">
                <g
                  id="g309_00000085223661773691852920000007143276347775773106_"
                  transform="translate(256.0001,16.0532)"
                >
                  <path
                    id="path311_00000143610996760876491470000018291185301824192676_"
                    className="st0"
                    d="M61.7,510.6V229.7"
                  />
                </g>
              </g>
            </g>
            <g
              id="g313_00000087402228967913607750000013542979888950572990_"
              transform="translate(256.2143,339.64)"
            >
              <path
                id="path315_00000072250502242260906570000012982120696636855180_"
                className="st0"
                d="M61.7-46.1l24.1-24.1"
              />
            </g>
            <g
              id="g317_00000144324384770236433450000010706388833064326792_"
              transform="translate(254.0833,294.5028)"
            >
              <path
                id="path319_00000003793309719146013510000005767895218625278114_"
                className="st0"
                d="M62.3,31.6L33.5,2.8"
              />
            </g>
          </g>
        </g>
        <g id="tree2_crown">
          <g>
            <path
              id="path367_00000049205916513367705960000016995125162229440175_"
              className="st0"
              d="M220.7,265.1L220.7,265.1"
            />
            <path
              className="st0"
              d="M223.1,235.9c12.7-39.1,49.3-67.4,92.7-67.7c54.3-0.4,98.6,43.3,99,97.5s-43.3,98.6-97.5,99
                c-44,0.3-81.5-28.4-94.3-68.2"
            />
          </g>
        </g>
        <g id="tree3">
          <g>
            <path
              id="path331_00000074433479968224893740000000799138861928723615_"
              className="st0"
              d="M487.4,375.4c1.1-4.2,1.7-8.6,1.7-13.1
                c0-28.6-23.2-51.8-51.8-51.8c-28.6,0-51.8,23.2-51.8,51.8c0,8.2,1.9,16,5.4,23c-21.3,5.3-37,24.5-37,47.4
                c0,27,21.9,48.8,48.8,48.8c11.4,0,22-4,30.3-10.6c9.1,6.6,20.4,10.6,32.5,10.6c30.5,0,55.3-24.8,55.3-55.3
                C520.7,403.5,507,383.9,487.4,375.4z"
            />
            <path
              id="path335_00000133529249501774491800000001121833324404301716_"
              className="st0"
              d="M432.9,393.7v138.9"
            />
            <path
              id="path339_00000091016268365491899440000006217945722853640349_"
              className="st0"
              d="M432.9,424.7l28.7-28.7"
            />
            <path
              id="path343_00000026121945494366407270000012531208447308227991_"
              className="st0"
              d="M432.9,450.7l-27-27"
            />
          </g>
        </g>
        <g id="Ebene_13" />
        <g id="sun">
          <path
            id="path351_00000080907085703563276340000007387281039162803086_"
            className="st0"
            d="M503,238.3c9.8,12.1,7.9,29.9-4.2,39.7
            s-29.9,7.9-39.7-4.2c-9.8-12.1-7.9-29.9,4.2-39.7C475.4,224.3,493.1,226.1,503,238.3z"
          />
        </g>
        <g id="ray1">
          <g
            id="g313_00000054983407209425468730000012118883313508162450_"
            transform="translate(256.2143,339.64)"
          >
            <path
              id="path315_00000064338846599991359660000006553724515629699718_"
              className="st0"
              d="M186.4-126.8L165-153.3"
            />
          </g>
        </g>
        <g id="ray2">
          <g
            id="g313_00000168823818658105376620000016058114441662269859_"
            transform="translate(256.2143,339.64)"
          >
            <path
              id="path315_00000084509288410993968270000002502143270469128892_"
              className="st0"
              d="M230.6-139.3l3.6-33.9"
            />
          </g>
        </g>
        <g id="ray3">
          <g
            id="g313_00000102516232788486669360000014948843691824333445_"
            transform="translate(256.2143,339.64)"
          >
            <path
              id="path315_00000155840239025619716990000005582911028657875606_"
              className="st0"
              d="M271.2-121.1l26.5-21.4"
            />
          </g>
        </g>
        <g id="ray4">
          <g
            id="g313_00000139296268519978477050000006839257545351640734_"
            transform="translate(256.2143,339.64)"
          >
            <path
              id="path315_00000079472365808303518720000001733683037747780740_"
              className="st0"
              d="M278.7-79.8l33.9,3.6"
            />
          </g>
        </g>
        <g id="ray5">
          <g
            id="g313_00000176014616113561404100000001441290244122468493_"
            transform="translate(256.2143,339.64)"
          >
            <path
              id="path315_00000028299300536909298710000007271883265956211128_"
              className="st0"
              d="M280.5-14.6l-21.4-26.5"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default Loader;
